import React, { useEffect, useMemo } from "react";
import s from "./InformationBlock.module.scss";
import { Link } from "react-router-dom";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getContactLinks,
  getMoreAboutDiseses,
  getUsefullLinks,
} from "../../redux/InformationSlice";
import { useTranslation } from "react-i18next";
import { buildContactLinksMap } from "../../utils/contactLinks";

const InformationBlock = () => {
  const dispatch: AppDispatch = useDispatch();
  const contactLinks = useSelector((state: RootState) => state.info.contactLinks);
  const { t } = useTranslation();
  const links = useMemo(() => buildContactLinksMap(contactLinks), [contactLinks]);

  useEffect(() => {
    if (!contactLinks?.length) {
      dispatch(getContactLinks());
    }
  }, [dispatch, contactLinks]);

  return (
    <div className={s.content}>
      <img
        src="/images/yellow_top.svg"
        alt="Yellow Top"
        className={s.top_img}
      />
      <div className={s.yellow}>
        <div className={s.info}>
          <div className={s.h2}>{t("ИНФОРМАЦИОННЫЙ БЛОК")}</div>
          <div className={s.subtitle}>
            {t("В данном разделе вы можете найти полезную информацию")}
          </div>
        </div>
        <div className={s.info_blocks}>
          <div className={s.info_item}>
            <div className={s.info_img}>
              <img src="/images/HIV test.svg" alt="" className={s.img} />
            </div>
            <div className={s.info_title}>{t("Где пройти обследования")}</div>
            <Link to="/checkup/kyrgyzstan">
              <div className={s.info_button}>{t("Узнать больше")}</div>
            </Link>
          </div>
          <div className={s.info_item}>
            <div className={s.info_img}>
              <img src="/images/HIV Info2.svg" alt="" className={s.img} />
            </div>

            <div className={s.info_title}>
              {t("Узнайте больше о ВИЧ, туберкулёзе и сифилисе")}
            </div>

            <Link
              to="/about/diseases"
              onClick={() => dispatch(getMoreAboutDiseses())}
            >
              <div className={s.info_button}>{t("Узнать больше")}</div>
            </Link>
          </div>
          <div className={s.info_item}>
            <div className={s.info_img}>
              <img src="/images/Links.svg" alt="" className={s.img} />
            </div>
            <div className={s.info_title}>{t("Полезные ссылки")}</div>
            <Link to="/links" onClick={() => dispatch(getUsefullLinks())}>
              <div className={s.info_button}>{t("Узнать больше")}</div>
            </Link>
          </div>
        </div>

        <div className={s.h2}>{t("МЫ ОТВЕЧАЕМ НА ВОПРОСЫ")}</div>
        <div className={s.info_blocks}>
          <Link
            to={links.consultant}
            target="_blank"
            rel="noopener noreferrer"
            className={s.info_item}
          >
            <div className={s.info_img}>
              <img src="/images/Consultation.svg" alt="" className={s.img} />
            </div>
            <div className={s.info_title}>{t("Связаться с консультантом")}</div>
            <div className={s.info_button}>{t("Задать вопрос")}</div>
          </Link>
          <Link
            to={links.jurist}
            target="_blank"
            rel="noopener noreferrer"
            className={s.info_item}
          >
            <div className={s.info_img}>
              <img
                src="/images/Legal Assistance.svg"
                alt=""
                className={s.img}
              />
            </div>
            <div className={s.info_title}>{t("Связаться с юристом")}</div>
            <div className={s.info_button}>{t("Задать вопрос")}</div>
          </Link>
          <Link
            to={links.ai}
            target="_blank"
            rel="noopener noreferrer"
            className={s.info_item}
          >
            <div className={s.info_img}>
              <img src="/images/AI bot.svg" alt="" className={s.img} />
            </div>
            <div className={s.info_title}>{t("Чат с ИИ")}</div>
            <div className={s.info_button}>{t("Задать вопрос")}</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InformationBlock;
